/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { NumberField } from 'sarsaparilla';

export default function NumericalAvailabilityFilter({
    onChange,
    value,
    maxValue,
    minValue,
    label,
    disabled,
    id,
}) {
    const onInputChange = (newValue) => {
        if (newValue === '') {
            onChange({ value: '' });
            return;
        }

        let valueUpdated = newValue;

        if (value > maxValue) {
            valueUpdated = maxValue;
        } else if (value < minValue) {
            valueUpdated = minValue;
        }

        onChange({ value: valueUpdated });
    };

    useEffect(() => {
        if (value === '') {
            onInputChange(0);
        }
    }, []);

    return (
        <div data-testid="numerical-availability-filter" className="center-content">
            <NumberField
                id={`number-input-${id}`}
                min={minValue}
                max={maxValue}
                value={value}
                units="members"
                step="1"
                visualLabel={`${label} (${maxValue} max)`}
                visualLabelPosition="left"
                label="Group Size"
                isDisabled={disabled}
                onChange={(e) => onInputChange(e)}
            />
        </div>
    );
}

NumericalAvailabilityFilter.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string,
};

NumericalAvailabilityFilter.defaultProps = {
    value: '',
    onChange: () => {},
    label: '',
    minValue: 0,
    maxValue: 1,
    id: '',
};
